import React, { useState } from "react";
import Layout from "../../Layout";
import LabOrderHistory from "./labOrders";
import MedicineOrderHistory from "./medicineOrders";

function OrderHistory() {
  const [activeTab, setActiveTab] = useState("DRUG");

  return (
    <Layout>
      <div className="px-5">
        <div className="container h-[550px] overflow-y-scroll border-2 w-full mx-auto bg-white rounded-lg p-4 mt-6">
          <h2 className="font-bold text-lg">Order History</h2>
          <div className="flex mt-4 mb-4">
            {["DRUG", "LAB"].map((tab, idx) => (
              <button
                key={idx}
                className={`px-4 py-2 ${tab === "DRUG" ? "rounded-l-md" : tab === "OPSERVICE" ? "rounded-r-md" : ""} 
                                        ${activeTab === tab ? "bg-[#189FAA] text-white" : "bg-gray-200"}`}
                onClick={() => setActiveTab(tab)}
              >
                {tab === "DRUG" ? "Medicine Order" : "Lab Order"
                  // : "OP Service Order"
                }
              </button>
            ))}
          </div>

          {
            activeTab === "DRUG" ?
              (
                <MedicineOrderHistory />
              )
              :
              activeTab === "LAB" ?
                (
                  <LabOrderHistory />
                )
                :
                ''
          }
        </div>
      </div>
    </Layout>
  );
}

export default OrderHistory;
